import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import useArtistEventDetailsElement from '../../../hooks/artistEvents/useArtistEventDetailsElement';
import { getEventDetailOrThrow } from '../../../api/taskEvents';
import ArtistSidebar from '../ArtistSidebar';
import PartnerEventCastingPanel from './PartnerEventCastingPanel';
import { formatDateOnlyJST, formatTimeJST } from '../../../utils/datetime';
const RelatedEventDetails = () => useArtistEventDetailsElement();
export default function ArtistEventDetails() {
  const generation = useRef(0);
  const { eventId } = useParams();
  const [event, setEvent] = useState(null); const [error, setError] = useState('');
  useEffect(() => { let active = true;
    const load = () => { const request = ++generation.current; setEvent(null); getEventDetailOrThrow(eventId).then(value => { if (active && request === generation.current) { setEvent(value); setError(''); } }).catch(() => { if (active && request === generation.current) { setEvent(null); setError('このイベントは現在閲覧できません。'); } }); };
    setEvent(null); load(); window.addEventListener('focus', load);
    return () => { active = false; generation.current++; window.removeEventListener('focus', load); };
  }, [eventId]);
  if (event && !event.partner_only) return <RelatedEventDetails />;
  return <div className="artist-dashboard"><ArtistSidebar /><main className="event-detail-page artist-event-detail-page"><div className="event-detail-container">
    {error ? <p role="alert">{error}</p> : !event ? <p>読み込み中…</p> : <><h2>{event.name}</h2><p>パートナー共有</p>
      <p>{formatDateOnlyJST(event.event_date)}　{formatTimeJST(event.start_time)}　{event.venue_name || event.venue}</p>
      <p>{event.estimated_duration_text}　{event.performance_format_text}</p>
      {event.canceled_at && <p>このイベントは中止されています。</p>}
      {(event.performances || []).map(p => <p key={p.id}>{p.performance_name}　{formatDateOnlyJST(p.performance_date)}　{formatTimeJST(p.start_time)}　{p.venue_name || p.venue_name_snapshot}　{p.estimated_duration_text || event.estimated_duration_text}　{p.performance_format_text || event.performance_format_text}</p>)}
      <PartnerEventCastingPanel eventId={eventId} /></>}
  </div></main></div>;
}
